<template>
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.1351 1.94954H18.1856V0H16.8866V1.94954H6.4949V0H5.19594V1.94954H3.24859C1.45819 1.94954 0 3.40654 0 5.19813V20.1372C0 21.9276 1.457 23.3858 3.24859 23.3858H20.1352C21.9256 23.3858 23.3838 21.9288 23.3838 20.1372L23.3827 8.44449V5.19591C23.3817 3.40551 21.9247 1.94954 20.1353 1.94954H20.1351ZM22.0825 20.135C22.0825 21.2088 21.2089 22.0824 20.1351 22.0824H3.24845C2.17248 22.0824 1.29891 21.2088 1.29891 20.135V8.44422H22.0823L22.0825 20.135ZM22.0825 7.14539H1.29905V5.19585C1.29905 4.12096 2.17259 3.24631 3.24859 3.24631H5.19813V4.54528H6.49493V3.24848H16.8866V4.54744H18.1856V3.24848H20.1351C21.2089 3.24848 22.0825 4.12093 22.0825 5.19583L22.0825 7.14539Z"
    ></path>
  </svg>
</template>
